import { css, DefaultTheme, ThemeProps } from 'styled-components';
import '@optimus-web/theme';
import { rem } from './rem';

export enum TextPreset {
    HIGHLIGHT_L = 'HIGHLIGHT_L',
    HIGHLIGHT_M = 'HIGHLIGHT_M',
    HIGHLIGHT_S = 'HIGHLIGHT_S',
    TITLE_L = 'TITLE_L',
    TITLE_M = 'TITLE_M',
    TITLE_S = 'TITLE_S',
    BODY_L = 'BODY_L',
    BODY_L_STRONG = 'BODY_L_STRONG',
    BODY_M = 'BODY_M',
    BODY_M_STRONG = 'BODY_M_STRONG',
    BODY_S = 'BODY_S',
    BODY_S_STRONG = 'BODY_S_STRONG',
    BODY_XS = 'BODY_XS',
    BODY_XS_STRONG = 'BODY_XS_STRONG',
}

export const getTextTokenPreset =
    (preset: `${TextPreset}`) =>
    ({ theme }: ThemeProps<DefaultTheme>) => {
        const { designTokens, settings } = theme;

        if (!designTokens) {
            return null;
        }

        const { fontSize, ...others } = designTokens[preset];

        return css`
            font-size: ${rem({
                size: fontSize,
                rootSize: settings.rootSize,
            })};
            ${others};
        `;
    };
